'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Icon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _RenderIf = require('../RenderIf');

var _RenderIf2 = _interopRequireDefault(_RenderIf);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Icon(_ref) {
  var icon = _ref.icon,
      isVisible = _ref.isVisible,
      position = _ref.position;

  var getIconClassNames = function getIconClassNames() {
    return (0, _classnames2.default)('rainbow-picklist-option_icon', 'rainbow-picklist-option_icon--' + position);
  };

  return _react2.default.createElement(_RenderIf2.default, {
    isTrue: isVisible
  }, _react2.default.createElement('span', {
    className: getIconClassNames()
  }, icon));
}

Icon.propTypes = {
  icon: _propTypes2.default.node,
  isVisible: _propTypes2.default.bool.isRequired,
  position: _propTypes2.default.string.isRequired
};
Icon.defaultProps = {
  icon: null
};